// extracted by extract-css-chunks-webpack-plugin
module.exports = {"table":"H9IToL","row":"_2VMS6r","entry":"_1bnNmW","city":"_3QsdR4","disclaimer":"_2uOS0w","header":"iCNbO4"};